import { GetEnpsInsightsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface Params {
  managerId?: string
}

export const useEnpsInsight = ({ managerId }: Params = {}) => {
  const { loading, data, refetch } = useQuery(GetEnpsInsightsDocument, { variables: { managerId } })

  const nodes = data?.engagementInsights.enpsInsightsConnection.nodes ?? []
  const enpsInsight = nodes[0] ?? null

  return {
    loading,
    enpsInsight,
    refetch,
  }
}
